import React from "react";
import ProfileIcon from "../../../../components/uiElements/icons/profileIcons/ProfileIcon";
import Modals from "../../../../components/uiElements/popupModal/modal";

const LockNoteModal = ({ onLock, onSaveAsTemplate, isOpen, closeModal }) => {
  return (
    <>
      <Modals
        isOpen={isOpen}
        onRequestClose={() => closeModal}
        title="Lock Notes"
        styles={{
          content: {
            minWidth: "500px",
            maxWidth: "500px",
            minHeight: "420px",
            maxHeight: "420px",
          },
        }}
        btnDark={{
          label: "Save",
          onclick: () => {
            onLock();
            closeModal();
          },
        }}
        btnOutline={{
          label: "Save as Note & Template",
          onclick: () => {
            onSaveAsTemplate();
            closeModal();
          },
        }}
      >
        <>
          <div className="d-flex justify-content-center my-5">
            <ProfileIcon type="lock" />
          </div>
        </>
      </Modals>
    </>
  );
};

export default LockNoteModal;
